/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_heat_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What data does a heatmap need?`)
};

const es_heat_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué datos necesita un mapa de calor?`)
};

const de_heat_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Daten benötigt eine Heatmap?`)
};

const nl_heat_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke data heeft een heatmap nodig?`)
};

const fr_heat_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelles données une carte de chaleur nécessite-t-elle ?`)
};

const it_heat_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che dati servono per una mappa di calore?`)
};

const pt_br2_heat_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que dados um mapa de calor precisa?`)
};

const pt_heat_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que dados precisa um mapa de calor?`)
};

const ja_heat_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヒートマップにはどのようなデータが必要ですか？`)
};

const zh_heat_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`热力图需要什么数据？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const heat_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.heat_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("heat_faq_q1", locale)
	if (locale === "en") return en_heat_faq_q1(inputs)
	if (locale === "es") return es_heat_faq_q1(inputs)
	if (locale === "de") return de_heat_faq_q1(inputs)
	if (locale === "nl") return nl_heat_faq_q1(inputs)
	if (locale === "fr") return fr_heat_faq_q1(inputs)
	if (locale === "it") return it_heat_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_heat_faq_q1(inputs)
	if (locale === "pt") return pt_heat_faq_q1(inputs)
	if (locale === "ja") return ja_heat_faq_q1(inputs)
	return zh_heat_faq_q1(inputs)
};